import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonTranslateModule } from "../../utils/common-translate.module";
import { OrganizationSwitcherComponent } from "./organization-switcher.component";

@NgModule({
  declarations: [OrganizationSwitcherComponent],
  imports: [CommonModule, CommonTranslateModule, MatIconModule, MatTooltipModule],
  exports: [OrganizationSwitcherComponent],
})
export class OrganizationSwitcherModule {}
